/**
 * Updates the native mobile browser system status bar panel color.
 * Supports both iOS Safari (iOS 15+) and Android Chrome.
 * @param {string} hexColor - The color string (e.g., '#1976D2' or '#4CAF50')
 */
export function updateMobileSystemBar(hexColor) {
    if (!hexColor) return;
    
    let metaThemeColor = document.querySelector('meta[name="theme-color"]');
    
    if (!metaThemeColor) {
        metaThemeColor = document.createElement('meta');
        metaThemeColor.setAttribute('name', 'theme-color');
        document.head.appendChild(metaThemeColor);
    }
    
    metaThemeColor.setAttribute('content', hexColor);
}
